import { RegistrationContainer } from '@/modules/authentication/presentation/containers';

export const RegistrationScreen = () => {
	return <RegistrationContainer />;
};
